/**
 * @description MPX Asset Type from MPX metadata.assetType field
 */
export enum MPXAssetType {
	/**
	 * DASH streams using CBCS encryption and the CMAF format
	 * @type {MPXAssetType.DASH_CBCS_CMAF}
	 */
	DASH_CBCS_CMAF = 'DASH_CBCS_CMAF',

	/**
	 * DASH streams using CENC encryption
	 * @type {MPXAssetType.DASH_CENC}
	 */
	DASH_CENC = 'DASH_CENC',

	DASH_CENC_HDR = 'DASH_CENC_HDR',

	DASH_CENC_HDR10 = 'DASH_CENC_HDR10',

	/**
	 * DASH streams using CENC encryption with pre-conditioned content
	 * @type {MPXAssetType.DASH_CENC_PRECON}
	 */
	DASH_CENC_PRECON = 'DASH_CENC_PRECON',

	/**
	 * DASH streams using CENC encryption and a legacy format
	 * @type {MPXAssetType.DASH_CENC_LGCY}
	 */
	DASH_CENC_LGCY = 'DASH_CENC_LGCY',

	/**
	 * DASH streams using the CMAF format for clips & trailers
	 * @type {MPXAssetType.DASH_CMAF}
	 */
	DASH_CMAF = 'DASH_CMAF',

	/**
	 * DASH streams for live
	 * @type {MPXAssetType.DASH_LIVE}
	 */
	DASH_LIVE = 'DASH_LIVE',

	/**
	 * DASH streams for clips & trailers
	 * @type {MPXAssetType.DASH_TA}
	 */
	DASH_TA = 'DASH_TA',

	HLS_AES = 'HLS AES',

	/**
	 * HLS streams using CBCS encryption and the CMAF format
	 * @type {MPXAssetType.HLS_CBCS_CMAF}
	 */
	HLS_CBCS_CMAF = 'HLS_CBCS_CMAF',

	/**
	 * HLS streams using the CMAF format for clips & trailers
	 * @type {MPXAssetType.HLS_CMAF}
	 */
	HLS_CMAF = 'HLS_CMAF',

	/**
	 * HLS streams using FPS encryption
	 * @type {MPXAssetType.HLS_FPS}
	 */
	HLS_FPS = 'HLS_FPS',

	HLS_FPS_HDR = 'HLS_FPS_HDR',

	/**
	 * HLS streams using FPS encryption with pre-conditioned content
	 * @type {MPXAssetType.HLS_FPS_PRECON}
	 */
	HLS_FPS_PRECON = 'HLS_FPS_PRECON',

	/**
	 * HLS streams for live
	 * @type {MPXAssetType.HLS_LIVE}
	 */
	HLS_LIVE = 'HLS_LIVE',

	/**
	 * HLS streams for clips & trailers
	 * @type {MPXAssetType.HLS_TA}
	 */
	HLS_TA = 'HLS_TA',
}